import { render, staticRenderFns } from "./ReportCardPreviewModal.vue?vue&type=template&id=09659d71&"
import script from "./ReportCardPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./ReportCardPreviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports